import React, { Component, Fragment } from "react";
import Slide from "./slide";
import NextArrow from "./nextArrow";
import PrevArrow from "./prevArrow";
import KeyboardEventHandler from "react-keyboard-event-handler";
import { Swipeable } from "react-swipeable";

class EzSlider extends Component {
  constructor(props) {
    super(props);
    let startingSlides = [];

    for (
      let i = props.settings.initialSlide;
      i < props.settings.slidesToShow + props.settings.initialSlide;
      i++
    ) {
      startingSlides.push(i);
    }

    this.state = {
      key: "n/a",
      nextSlide: 0,
      showSlides: startingSlides,
      styles: {
        width: this.props.settings.maxWidth + "px",
        border: "0px solid red",
        height: "100%",
        position: "relative"
      },
      slideInnerStyle: {
        width: "100%",
        float: "left"
      }
    };
  }

  static defaultProps = {
    navTop: 355,
    navColor: "#fff",
    slides: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
    instanceID: "idneeded",
    settings: {
      className: "center",
      centerMode: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      swipeToSlide: true,
      maxWidth: 1000,
      minWidth: 1000
    },
    arrowStyles: {
      position: "absolute"
    },
    leftArrowStyles: {
      left: "10px"
    },
    rightArrowStyles: {
      right: "10px"
    },
    slideOuterStyle: {
      float: "left"
    }
  };

  handleKeyPress = (key, e) => {
    if (key === "left") {
      this.goToPrevSlide();
    }
    if (key === "right") {
      this.goToNextSlide();
    }
  };

  goToPrevSlide = () => {
    const slides = this.props.slides;
    for (let i = 0; i < this.props.settings.slidesToScroll; i++) {
      slides.unshift(slides.pop());
    }
    this.setState({
      slides: slides
    });
  };

  goToNextSlide = () => {
    const slides = this.props.slides;
    for (let i = 0; i < this.props.settings.slidesToScroll; i++) {
      slides.push(slides.shift());
    }
    this.setState({
      slides: slides
    });
  };

  renderSlides() {
    this.props.slides.sort(() => Math.random() - 0.5);
    return this.props.slides.map((content, i) => (
      <Slide
        key={i}
        i={i}
        tabIndex="-1"
        show={this.props.settings.slidesToShow}
        styles={this.props.slideOuterStyle}
        navColor="#444"
        hasBorder={this.props.borderRight}
        padding={this.props.padding}
        isFull={this.props.settings.isFull}
      >
        <div alt="" style={{ ...this.state.slideInnerStyle }} tabIndex="-1" />
        {content}
      </Slide>
    ));
  }

  render() {
    const config = {
      onSwipedLeft: () => this.goToNextSlide(),
      onSwipedRight: () => this.goToPrevSlide(),
      trackMouse: true
    };

    return (
      <Swipeable
        className="Swipe"
        tabIndex="-1"
        style={{ width: "100%" }}
        {...config}
      >
        <ul
          tabIndex="-1"
          className="sliderContainer"
          style={{ ...this.state.styles, ...this.props.ulStyles }}
          onKeyPress={this.handleKeyPress}
        >
          <KeyboardEventHandler
            handleKeys={["left", "right"]}
            onKeyEvent={(key, e) => this.handleKeyPress(key, e)}
          />
          {this.renderSlides()}
          {this.props.slides.length > 1 &&
          this.props.settings.arrowNav.useArrow === true ? (
            <Fragment>
              <PrevArrow
                id={this.props.instanceID + "prev"}
                settings={this.props.settings.arrowNav}
                onClick={this.goToPrevSlide}
                fill={this.props.navColor}
                hoverColor={this.props.hoverColor}
              />
              <NextArrow
                id={this.props.instanceID + "next"}
                settings={this.props.settings.arrowNav}
                onClick={this.goToNextSlide}
                fill={this.props.navColor}
                hoverColor={this.props.hoverColor}
              />
            </Fragment>
          ) : null}
        </ul>
      </Swipeable>
    );
  }
}

export default EzSlider;
